export default {
  sidebar: {
    dashboard: "Dashboard",
    transfer: "Transfer",
    trade: "Trade",
    transactions: "Transactions",
    auditLogs: "Audit Logs",
    approvals: "Approvals",
    configuration: "Configuration",
    transfers: "Transfers",
    charges: "Charges",
    mapping: "Mapping",
    manageFunds: "Manage Funds",
    withdrawal: "Withdrawal",
    userManagement: "User Management",
    supportAndDocs: "Support & Docs",
    logoAlt: {
      platform: "LMAX One Platform Portal",
      client: "LMAX One Client Portal",
    },
  },
  hubAppSlot: {
    loadError: "This section failed to load. Refresh the page to try again.",
  },
};
